import { event } from '@blocket/tracking-pulse'
import log from 'sentry/log'

// To anonymize user_id in object.url and origin.url we have implemented logic in
// https://github.schibsted.io/spt-dataanalytics/routing/blob/master/src/main/resources/transforms/blocket-google-analytics-hit-mapping.jslt
// If you want to add user_id in any other paramteter, make sure to anonymize that as well, so we do not send it to any third party!

// this page should NOT have a gtm.pageView event. It expose the url with the user_id to third paries.

export const profilePagePublicView = () => {
  try {
    event({
      type: 'View',
      name: 'View Public Profile Page',
      object: {
        type: 'Page',
        id: 'profile_page_public',
      },
    })
  } catch (error) {
    log.message(`Public Profile Page tracking error ${error}`)
  }
}

export const trackReportUserModalView = () => {
  try {
    event({
      type: 'View',
      name: 'View Report User Modal',
      object: {
        type: 'Page',
        id: 'report_user_public_profile',
      },
    })
  } catch (error) {
    log.message(`Public Profile Report User tracking error ${error}`)
  }
}

export const trackSubmitReportUser = () => {
  try {
    event({
      type: 'Engagement',
      name: 'Submit Report User',
      action: 'Click',
      object: {
        type: 'UIElement',
        id: 'report_user_public_profile:element:report_user_submit',
      },
    })
  } catch (error) {
    log.message(`Public Profile Report User Submit Button tracking error ${error}`)
  }
}

export const trackReportUserModalThankYouView = () => {
  try {
    event({
      type: 'View',
      name: 'View Report User Modal Thank You Page',
      object: {
        type: 'Page',
        id: 'report_user_public_profile_thank_you_page',
      },
    })
  } catch (error) {
    log.message(`Public Profile Report User tracking error ${error}`)
  }
}

export const trackReportUserModalInputErrorView = (description) => {
  try {
    event({
      type: 'View',
      name: 'Report User Modal Input Error ',
      object: {
        type: 'Error',
        id: 'report_user_public_profile_error',
        cause: [
          {
            description: `${description}`,
          },
        ],
      },
    })
  } catch (error) {
    log.message(`Public Profile Report User Error tracking ${error}`)
  }
}

export const trackReportUserCustomerSupport = () => {
  try {
    event({
      type: 'Engagement',
      name: 'View Report User Customer Support Clicked',
      action: 'Clicked',
      object: {
        type: 'UIElement',
        id: 'report_user_public_profile:element:customer_support_clicked',
      },
    })
  } catch (error) {
    log.message(`Public Profile Report User Customer Support clicked ${error}`)
  }
}

export const trackReviewsInfoAreaExpand = () => {
  try {
    event({
      type: 'Engagement',
      name: 'Expand Rating & Reviews info area',
      action: 'Clicked',
      object: {
        type: 'UIElement',
        id: 'reviews_public_profile:expand_info_area',
      },
    })
  } catch (error) {
    log.message(`Public Profile Reviews info area expand ${error}`)
  }
}

export const trackReviewsInfoAreaClickLink = () => {
  try {
    event({
      type: 'Engagement',
      name: 'Click link in Rating & Reviews info area',
      action: 'Clicked',
      object: {
        type: 'UIElement',
        id: 'reviews_public_profile:click_link_info_area',
      },
    })
  } catch (error) {
    log.message(`Public Profile Reviews info area click link ${error}`)
  }
}
